// js
import React from 'react';
import EngagementItem from './EngagementItem';


const EngagementSplunkItem = props => (
  <EngagementItem
    columnWidths={[5, 5, 2]}
    namePlaceholder='Presenter name'
    detailsPlaceholder='Presenter title'
    {...props}
  />
);

export default EngagementSplunkItem;



// WEBPACK FOOTER //
// ./src/components/analytics/EngagementSplunkItem.js